/**
 * TerminalWindow — retro-terminal window shell with CRT overlay.
 *
 * Renders a branded window frame (no macOS traffic-light dots) with a
 * header bar showing the prompt label and a blinking caret, and a screen
 * body overlaid with the .crt-screen effect (scanlines + vignette + roll).
 *
 * Props:
 *   label     — prompt string shown in the header bar (default 'artificers@leak-meter:~$')
 *   children  — content rendered inside the screen body
 *   className — composed onto the outer wrapper
 *
 * CRT overlay is defined in src/styles/terminal.css.
 * terminal-screen / terminal-bar colours are in src/styles/tokens.js.
 */
export default function TerminalWindow({
  label = 'artificers@leak-meter:~$',
  children,
  className = '',
}) {
  const isDefault = label === 'artificers@leak-meter:~$';

  return (
    <div
      className={[
        'rounded-[10px] border border-white/[.08] overflow-hidden bg-terminal-screen',
        'shadow-[0_30px_60px_-30px_rgba(0,0,0,.8)]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {/* Header bar */}
      <div className="bg-terminal-bar border-b border-white/[.06] px-4 py-2.5 flex items-center">
        {isDefault ? (
          <span className="font-mono text-mono-sm select-none" aria-label={label}>
            <span className="text-ink-300">artificers</span>
            <span className="text-ink-200">@leak-meter</span>
            <span className="text-ink-400">:~$</span>
            <span className="term-caret" aria-hidden="true" />
          </span>
        ) : (
          <span className="font-mono text-mono-sm text-ink-200 select-none">
            {label}
            <span className="term-caret" aria-hidden="true" />
          </span>
        )}
      </div>

      {/* Screen body with CRT overlay */}
      <div className="crt-screen px-7 py-8">
        <div className="relative z-[1]">
          {children}
        </div>
      </div>
    </div>
  );
}
